import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
export function FaqSection() {
  const faqs = [{
    q: 'No tengo tiempo',
    a: 'Nuestros horarios están diseñados para personas ocupadas. Sesiones efectivas desde 45 minutos.'
  }, {
    q: 'Soy principiante, me da vergüenza',
    a: 'Empezamos desde cero contigo. Nadie te juzga aquí — todos estuvieron donde estás tú.'
  }, {
    q: 'He intentado antes y no funciona',
    a: 'Exacto. Porque antes no tenías el Sistema 3en1. Esta vez es diferente.'
  }, {
    q: '¿Es muy caro?',
    a: 'La clase de prueba es gratis. Ven primero, evalúas, luego decides. Sin presión.'
  }, {
    q: 'Queda lejos de mi casa',
    a: 'Estamos en pleno San Miguel, con fácil acceso desde múltiples distritos. Y vale el viaje.'
  }, {
    q: 'No sé si voy a ser constante',
    a: 'Nuestra comunidad y seguimiento personalizado existen exactamente para eso. No estás solo.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="py-24 bg-gym-charcoal" data-id="element-39">
      <div className="max-w-3xl mx-auto px-4" data-id="element-40">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-41">
          <h2 className="text-3xl md:text-5xl font-bold uppercase tracking-wide text-white" data-id="element-42">
            Preguntas <span className="text-gym-gold" data-id="element-43">Frecuentes</span>
          </h2>
        </motion.div>

        <div className="space-y-4" data-id="element-44">
          {faqs.map((faq, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: index * 0.1
        }} className="bg-gym-dark border border-gym-charcoalLight rounded-xl overflow-hidden" data-id="element-45">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-6 py-5 text-left flex items-center justify-between focus:outline-none" data-id="element-46">
                <span className="text-lg font-bold text-white uppercase tracking-wider" data-id="element-47">
                  {faq.q}
                </span>
                <ChevronDown size={24} className={`text-gym-green transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-48" />
              </button>

              <AnimatePresence data-id="element-49">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-50">
                    <div className="px-6 pb-5 text-gray-400 text-lg border-t border-gym-charcoalLight/50 pt-4" data-id="element-51">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>
      </div>
    </section>;
}